import { GraphQLNonNull, GraphQLFieldConfig } from 'graphql'
import {
  CustomMetadataSettings,
  customMetadataSettingsArgs,
  CustomMetadataSettingsArgs,
  CustomMetadataSettingsType
} from '../types/custom-metadata-settings'
import { Context } from '../shared'

export const customMetadataSettings: GraphQLFieldConfig<
  any,
  Context,
  CustomMetadataSettingsArgs
> = {
  description: 'Get custom metadata settings required by Organization',
  type: new GraphQLNonNull(CustomMetadataSettingsType),
  args: customMetadataSettingsArgs,
  async resolve(
    _source,
    { input: { organizationID } },
    context
  ): Promise<CustomMetadataSettings> {
    return context.connector.get(`${organizationID}/metadata/settings`)
  }
}
